import AppManagementRequest from './AppManagementRequest';

export default class NewAppRequest extends AppManagementRequest {
	constructor(newApp, currentUser) {
		super(newApp, currentUser);
		this.workQueType = null;
		this.systemID = null;
		this.systemName = null;
		this.appSystemOrder = null;
	}
}
